module.exports = __webpack_public_path__ + "assets/marked.4effe7a2.svg";